import React, { useState } from 'react'
import { Link } from 'gatsby'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import '../styles/custom-style.min.css'
// import "../styles/main.css"
import '../styles/main_2.css'
import '../styles/header.css'
import '../styles/element.css'
import '../styles/fontawesome.css'
import '../styles/survey.css'
import Contact from '../components/contact'

const Header = ({ lang }) => {
  const [isDropdown, setIsDropdown] = useState(false)
  const [isOpenContact, setOpenContact] = useState(false)

  return (
    <>
      <div className="container desktop_res mt-2">
        <div className="row">
          <div className="col-md-4">
            <a className="navbar-brand logo_header">
              <img
                className="d-block w-100 img-fluid"
                src={'/securetravel/images/sompo_cimb_logo_new.png'}
                alt="logo"
              />
            </a>
          </div>
          <div className="col-md-8">
            <div className="header-right">
              {/* <div className="covid-ribbon-container">
							<img className="d-block w-100 img-fluid covid-ribbon" src={"/securetravel/images/covid-ribbon.svg"} alt="logo" />
						</div> */}
              <div className="prod-name_right mt-3">Secure Travel</div>
            </div>
          </div>
        </div>
      </div>

      <nav className="navbar navbar-expand-lg mobile_res">
        <div className="container line-bottom online-menu_pad">
          <a className="navbar-brand logo_header" href="https://online.berjayasompo.com.my/">
            <img
              className="d-block w-100 img-fluid"
              src={'/securetravel/images/sompo_logo.svg'}
              alt="logo"
            />
          </a>
          <button
            className="navbar-toggler navbar-toggler-right mobile"
            type="button"
            data-toggle="collapse"
            data-target="#navbarResponsive"
            aria-controls="navbarResponsive"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarResponsive">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item mobile"></li>
              <li className="nav-item mobile">
                <a className="nav-link" href={lang.homeLink}>
                  {lang.home}
                </a>
              </li>
              <li className="nav-item mobile">
                <a
                  className="nav-link"
                  href="https://www.berjayasompo.com.my/claims"
                  target="_blank"
                  rel="noreferrer"
                >
                  {lang.howToClaim}
                </a>
              </li>

              <li className="nav-item mobile">
                <a className="nav-link" href="#" onClick={() => setOpenContact((v) => !v)}>
                  {lang.contactUs}
                </a>
              </li>
              {/* <li className="nav-item mobile">
                <a
                  className="nav-link"
                  href={lang.partnerWithUsLink}
                  target="_blank"
                  rel="noreferrer"
                >
                  {lang.partnerWithUs}
                </a>
              </li>
              <li className="nav-item mobile">
                <Link className="link nav-link no-line" to={lang.faqLink}>
                  {lang.faq}
                </Link>
              </li> */}
              {/* <li className="nav-item mobile">
						<a className="nav-link no-line" 
						   href="https://travel.berjayasompo.com.my/securetravel/highlights/partner.html"
						   target="_blank"
						   rel="noreferrer"
						 >Covid-19</a>
					</li> */}
            </ul>
          </div>
        </div>
        {/* <div className="covid-ribbon-container">
							<img className="d-block w-100 img-fluid covid-ribbon" src={"/securetravel/images/covid-ribbon.svg"} alt="logo" />
						</div> */}
        <ul className="navbar-nav ml-auto">
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle bold online-menu_pad2"
              href="#"
              id="navbarDropdownPortfolio"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Secure Travel
            </a>
            <div
              class="dropdown-menu dropdown-menu-right"
              aria-labelledby="navbarDropdownPortfolio"
            >
              <a class="dropdown-item" href={lang.productLinks.secureMotor}>
                Secure Motor
              </a>
              <a class="dropdown-item" href={lang.productLinks.secureHome}>
                Secure Home
              </a>
              <a class="dropdown-item" href={lang.productLinks.snatchMedz}>
                Snatch Medz+
              </a>
              <a class="dropdown-item" href={lang.productLinks.snatchShield}>
                Snatch Shield Plus
              </a>
            </div>
          </li>
        </ul>
      </nav>

      <div className="text-right header_element"></div>

      <div className="bread_navi_bg desktop_res">
        <div className="container">
          <div className="row">
            <div className="col-xl-10 col-lg-9 col-md-8">
              <nav role="navigation" className="bread_navi">
                <ul>
                  <li>
                    <a href={lang.homeLink}>{lang.home}</a>
                  </li>
                  <li>
                    <a
                      href="https://www.berjayasompo.com.my/claims"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {lang.howToClaim}
                    </a>
                  </li>

                  <li>
                    <a to="#" onClick={() => setOpenContact((v) => !v)}>
                      {lang.contactUs}
                    </a>
                  </li>
                  {/* <li>
                    <a href={lang.partnerWithUsLink} target="_blank" rel="noreferrer">
                      {lang.partnerWithUs}
                    </a>
                  </li>
                  <li>
                    <Link className="link" to={lang.faqLink}>
                      {lang.faq}
                    </Link>
                  </li> */}
                  {/* <li>
                <a 
                  href="https://travel.berjayasompo.com.my/securetravel/highlights/partner.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  Covid-19
                </a>
              </li>		 */}
                </ul>
              </nav>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-4">
              <nav className="navbar navbar-expand-lg">
                <div>
                  <ul className="navbar-nav ml-auto">
                    <Dropdown
                      nav={true}
                      isOpen={isDropdown}
                      toggle={() => setIsDropdown((prevState) => !prevState)}
                    >
                      <DropdownToggle className="navbar-nav_desk" caret tag="a" nav={true} href="#">
                        {lang.onlineProduct}
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem href={lang.productLinks.secureMotor}>
                          Secure Motor
                        </DropdownItem>
                        <DropdownItem href={lang.productLinks.secureHome}>Secure Home</DropdownItem>
                        <DropdownItem href={lang.productLinks.snatchMedz}>
                          Snatch Medz+
                        </DropdownItem>
                        <DropdownItem href={lang.productLinks.snatchShield}>
                          Snatch Shield Plus
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <Contact isOpen={isOpenContact} toggle={() => setOpenContact((v) => !v)} lang={lang} />
    </>
  )
}

export default Header
